import axios from "@/axios"; 

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    async getPortList(token) {
      try {
        const response = await axios.get(API_URL+"/olt-port-count/shr-olt/", {
          headers: {
            'X-Custom-Header': 'Bearer '+token
          }
        });
        return response.data;
      } catch (error) {
        console.error("Error retrieving user:", error);
        throw error; 
      }
    },
  };
